<template>
	<b-row>
		<b-col>
			<h4 class="mt-3">Attacks</h4>
			<b-table-simple responsive small bordered striped table-class="mb-0">
				<b-thead>
					<b-tr>
						<b-th></b-th>
						<b-th>=</b-th>
						<b-th>Mod</b-th>
						<b-th>BAB</b-th>
						<b-th></b-th>
						<b-th>=</b-th>
						<b-th>Mod</b-th>
						<b-th>BAB</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr>
						<b-td><strong>MLE</strong> <small class="text-muted">Melee</small></b-td>
						<b-td class="text-right"><strong>{{totalAttack('Melee',0)|bonus}}</strong></b-td>
						<b-td class="text-right">{{abilityMods.Strength|bonus}}</b-td>
						<b-td class="text-right">{{Character.Levels[currentLevel].BAB|bonus}}</b-td>

						<b-td><strong>THR</strong> <small class="text-muted">Thrown</small></b-td>
						<b-td class="text-right"><strong>{{totalAttack('Thrown',0)|bonus}}</strong></b-td>
						<b-td class="text-right">{{abilityMods.Strength|bonus}}</b-td>
						<b-td class="text-right">{{Character.Levels[currentLevel].BAB|bonus}}</b-td>
					</b-tr>
					<b-tr>
						<b-td><strong>RNG</strong> <small class="text-muted">Ranged</small></b-td>
						<b-td class="text-right"><strong>{{totalAttack('Ranged',0)|bonus}}</strong></b-td>
						<b-td class="text-right">{{abilityMods.Dexterity|bonus}}</b-td>
						<b-td class="text-right">{{Character.Levels[currentLevel].BAB|bonus}}</b-td>

						<b-td><strong>OPR</strong> <small class="text-muted">Operative</small></b-td>
						<b-td class="text-right"><strong>{{totalAttack('Operative',0)|bonus}}</strong></b-td>
						<b-td class="text-right">{{abilityMods.Dexterity|bonus}}</b-td>
						<b-td class="text-right">{{Character.Levels[currentLevel].BAB|bonus}}</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-col>
	</b-row>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters([
			'currentLevel',
		]),
		...mapGetters('character/abilityScores',[
			'abilityMods',
		]),
		...mapGetters('character/equipment',[
			'totalAttack',
		])
	}
}
</script>

<style scoped>

</style>